<template>
    <div class="p-3">
        <h3>Detail Pasien Dirawat</h3>
        <hr>

        <div class="row">
            <div class="col-md-3">
                <div class="card mb-3">
                    <div class="card-header text-white bg-primary">Data Pasien</div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tbody>
                                <tr>
                                    <td>No. RM</td>
                                    <td>{{ data_pasien.Medrec }}</td>
                                </tr>
                                <tr>
                                    <td>No. Registrasi</td>
                                    <td>{{ data_pasien.Regno }}</td>
                                </tr>
                                <tr>
                                    <td>Nama Pasien</td>
                                    <td>{{ data_pasien.Firstname }}</td>
                                </tr>
                                <tr>
                                    <td>Kategori</td>
                                    <td>{{ data_pasien.NmKategori }}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Kelamin</td>
                                    <td>{{ data_pasien.gender }}</td>
                                </tr>
                                <tr>
                                    <td>Umur</td>
                                    <td>{{ data_pasien.umur }}</td>
                                </tr>
                            </tbody>
                            
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="card mb-3">
                    <div class="card-header text-white bg-primary">Keterangan</div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tbody>
                                <tr>
                                    <td width="20%">Ruangan/Kelas</td>
                                    <td>{{ data_pasien.ruang_kelas }}</td>
                                </tr>
                                <tr>
                                    <td>Kamar/Nomor</td>
                                    <td>{{ data_pasien.nokamar }} / {{ data_pasien.NoTTidur }}</td>
                                </tr>
                                <tr>
                                    <td>Asal Perawatan</td>
                                    <td>{{ data_pasien.NMPoli }}</td>
                                </tr>
                                <tr>
                                    <td>Waktu Masuk Perawatan</td>
                                    <td>{{ data_pasien.waktu_masuk }}</td>
                                </tr>
                                <tr>
                                    <td>Lama Perawatan (Hari)</td>
                                    <td>{{ data_pasien.lama_rawat }}</td>
                                </tr>
                                <tr>
                                    <td>DPJP</td>
                                    <td>{{ data_pasien.NmDocRS }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header text-white bg-primary">Rincian Biaya</div>
                    <div class="card-body">
                        <div id="table-biaya">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Tindakan</th>
                                        <th>Biaya</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="data_pasien.bilRoom > 0">
                                        <td>Ruangan Rawat</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilRoom)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilIrna > 0">
                                        <td>Tindakan Ruangan</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilIrna)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilObat > 0">
                                        <td>Pemakaian Obat/Apotik</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilObat)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilBhp > 0">
                                        <td>Pemakaian BHP</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilBhp)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilLab > 0">
                                        <td>Laboratorium</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilLab)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilRad > 0">
                                        <td>Radiologi</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilRad)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilUgd > 0">
                                        <td>Tindakan UGD</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilUgd)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilOp > 0">
                                        <td>Tindakan Operasi</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilOp)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilFis > 0">
                                        <td>Tindakan Fisioterapi</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilFis)) }}</td>
                                    </tr>
                                    <tr v-if="data_pasien.bilVk > 0">
                                        <td>Tindakan VK</td>
                                        <td>{{ Intl.NumberFormat().format(Math.round(data_pasien.bilVk)) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Uang Muka</th>
                                        <th>{{ Intl.NumberFormat().format(data_pasien.uangMuka > 0 ? Math.round(data_pasien.uangMuka) : 0) }}</th>
                                    </tr>
                                    <tr>
                                        <th>Total</th>
                                        <th>{{ Intl.NumberFormat().format(data_pasien.realisasi > 0 ? Math.round(data_pasien.realisasi) : 0) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header text-white bg-primary">Histori Pindah Kamar</div>
                    <div class="card-body">
                        <div id="table-histori"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default{
    data(){
        return {
            Regno: '',
            data_pasien: [],
            data_pindah: []
        }
    },
    created(){
        this.Regno = this.$route.params.Regno,
        this.filter.page = this.$route.query.page ?? 1
    },
    mounted(){
        this.getDetail(),
        this.getHistori()
    },
    methods: {
        getDetail(){
            const uri = `/api/pasien-dirawat/get-detail?Regno=${this.Regno}`

            this.axios.get(uri).then(response => {
                const status = response.data.status;

                if(status == 'success'){
                    this.data_pasien = response.data.data_pasien;
                }
            })
        },

        getHistori(){
            const uri = `/api/pasien-dirawat/get-detail-pindah?Regno=${this.Regno}`
            const element = document.getElementById('table-histori')

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',

                columns: [
                    {title: 'No. Pindah', field: 'NoPindah'},
                    {title: 'Tanggal Pindah', field: 'waktu_masuk'},
                    {title: 'Ruang/Kelas', field: 'bangsal_kelas'},
                    {title: 'Kamar/Nomor', field: 'nomor_kamar'},
                    {title: 'Lama Perawatan (Hari)', field: 'lama_rawat'},
                ]
            })
        },
        AjaxResponse(url, params, response) {
            return response.data_pindah
        },
    }
}
</script>